import * as Sentry from '@sentry/browser'

export const sentryInit = () => {
    console.info('Initializing Sentry', {
        environment: import.meta.env.VITE_APP_ENV,
    })

    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
                maskAllInputs: true,
            }),
        ],
        environment: import.meta.env.VITE_APP_ENV,
        tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
        replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE),
        replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE),
        profilesSampleRate: Number(import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE),
        ignoreErrors: [
            'Non-Error promise rejection captured with value: Component not found',
            'Snapshot missing on Livewire component with id:',
            'Component not found:',
        ],
    })

    window.$sentry = {
        captureException: Sentry.captureException,
        captureMessage: Sentry.captureMessage,
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (window.USER_ID) {
            Sentry.setUser({ id: window.USER_ID })
        }
    })
}

if (import.meta.env.VITE_SENTRY_LARAVEL_DSN) {
    sentryInit()
}
